module.exports = __webpack_public_path__ + "static/media/provider1.ad28bedc.png";